class ProductRecommendations extends window.HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Below the fold, so fetch once it's getting close instead of during page load
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.fetchRecommendations();
      }, { rootMargin: "800px 0px" });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    fetchRecommendations() {
        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement("div")
                html.innerHTML = text
                const recommendations = html.querySelector("product-recommendations")

                if (recommendations?.innerHTML.trim().length) {
                    this.innerHTML = "";
                    this.appendChild(recommendations.firstElementChild);
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }
}

window.customElements.define('product-recommendations', ProductRecommendations)
